
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/sellers/[sellerId]",
      function () {
        return require("private-next-pages/default/desktop/sellers/[sellerId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/default/desktop/sellers/[sellerId]"])
      });
    }
  